import React from "react";
import { Space, Descriptions } from "antd";
import StepHeader from "../../Evaluation/StepHeader";
import { Config } from "../../../model_gen/config";

interface TestRunData {
  description?: string;
  config?: Config;
}

interface TestRunReviewProps {
  testRunData: TestRunData;
  testSetId: number;
}

const TestRunReview: React.FC<TestRunReviewProps> = ({ testRunData, testSetId }) => {
  return (
    <Space direction="vertical" size="large" style={{ width: "100%" }}>
      <StepHeader
        title="Review Test Run"
        description="Review your test run configuration before creating"
      />

      <Descriptions 
        bordered 
        column={1}
        size="middle"
        labelStyle={{ width: "200px", background: "#fafafa" }}
      >
        <Descriptions.Item label="Description">
          {testRunData.description || "No description provided"}
        </Descriptions.Item>
        
        <Descriptions.Item label="Test Set ID">
          {testSetId}
        </Descriptions.Item>

        <Descriptions.Item label="Model">
          {testRunData.config?.model || "No model selected"}
        </Descriptions.Item>

        {/* Add more configuration details here */}
      </Descriptions>
    </Space>
  );
};

export default TestRunReview;
